module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/01-a039e2c3af2dde1fc1507d0d7872295b.jpg";